import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { refundPolicy } from './legalContent';

const RefundPolicy = () => {
  return <LegalPageLayout document={refundPolicy} />;
};

export default RefundPolicy;
